import * as React from "react";
import { forwardRef } from "react";
const SvgInfoNegative = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 0A50 50 0 0 0 0 50a50 50 0 0 0 50 50 50 50 0 0 0 50-50A50 50 0 0 0 50 0m7.559 10.684a8.115 8.19 0 0 1 8.125 8.183 8.115 8.19 0 0 1-8.125 8.184 8.115 8.19 0 0 1-8.106-8.184 8.115 8.19 0 0 1 8.106-8.183m.058 25.566h3.34L49.57 75.762c-.63 2.26-.957 3.75-.957 4.453.46 2.127 2.103 1.674 3.457.84 1.667-1.371 3.663-3.868 5.996-7.461l1.895 1.113c-5.594 9.743-11.554 14.61-17.852 14.61-2.408 0-4.317-.659-5.761-1.993-2.8-3.262-2.18-6.966-1.172-10.39L42.89 50.37q1.111-3.835 1.113-5.781c-.353-2.12-2.106-3.087-3.945-3.106-.556 0-1.215.025-1.993.059l.723-2.227z" />
  </svg>
);
const ForwardRef = forwardRef(SvgInfoNegative);
export default ForwardRef;
